/* eslint-disable */
const __svg__ = {
    path: '../../web/static/images/icons/*.svg',
    name: 'spritemap-icons.svg',
};
